import { useCallback, useState } from 'react';
import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';

export interface WidgetConfigResponse {
    allowedDomains: string[];
    isAnonymousAccessEnabled: boolean;
    isWidgetEnabled: boolean;
    agentId: string;
}

export const useWidgetConfig = (containerAri: string) => {
    const [isLoading, setIsLoading] = useState(false);
    const [widgetConfig, setWidgetConfig] = useState<WidgetConfigResponse | null>(null);

    const fetch = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetchJson<WidgetConfigResponse>(
                `/gateway/api/assist/jsm/v1/configuration/surface?containerAri=${encodeURIComponent(containerAri)}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-product': 'rovo',
                        'x-experience-id': 'ai-mate',
                    },
                }
            );
            setWidgetConfig(response);
        } catch (error) {
            setWidgetConfig({
                isWidgetEnabled: false,
                isAnonymousAccessEnabled: false,
                allowedDomains: [],
                agentId: '',
            });
        } finally {
            setIsLoading(false);
        }
    }, [containerAri]);

    return {
        widgetConfig,
        fetch,
        isLoading,
    };
};
